/** Where a checklist setup is. `reading` = the browser is reading the picked
 * .xlsx; `building` = the one setup request is running on the server. */
export type ChecklistSetupStage = 'reading' | 'building';

/** "0:07", "1:42". */
export function formatElapsed(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/** The steps shown for a setup: an upload has a client-side read first. */
export function checklistSetupSteps(
  upload: boolean,
): { stage: ChecklistSetupStage | 'done'; label: string }[] {
  return [
    ...(upload ? [{ stage: 'reading' as const, label: 'Read your checklist file' }] : []),
    {
      stage: 'building' as const,
      label: upload
        ? 'Check the workbook and create the phases, categories and document requests'
        : 'Create the phases, categories and document requests',
    },
    { stage: 'done' as const, label: 'Checklist ready' },
  ];
}

